/* eslint-env serviceworker, worker */
import {frontAppConfig} from "./FrontAppConfig";
import {DateTime} from "mu-js-utils/lib/DateTime";
import {AppTL} from "./gen/tl";
import {notifier, Notifier} from "./Notifier";
import {urlEqual} from "./utils";

export class AppServiceWorker
{
    public offlinePages: string[] = ['/offline.html'];
    public offlineCacheVersion = `offline-${APP_VERSION}`;

    init() {
        self.addEventListener('install', (event) => {
            eventAwait(event, async() => {
                await this.install(event);
                const cache = await caches.open(this.offlineCacheVersion);
                for (const page of this.offlinePages) {
                    await cache.add(page);
                }
                await skipWaiting();
            });
        });

        self.addEventListener('activate', (event) => {
            eventAwait(event, async () => {
                for(const cacheKey of await caches.keys()) {
                    if (cacheKey !== this.offlineCacheVersion) {
                        await caches.delete(cacheKey);
                    }
                }
                await clients.claim();
            });
        });

        /* const messageCallbacks: Record<string, (...args:any[])=>void> = {
            tick: (loadUpdate: boolean) => this.tick(loadUpdate),
        };

        self.addEventListener('message', event => {
            if (messageCallbacks[event.data.call]) {
                messageCallbacks[event.data.call](...event.data.args);
            }
        }); */

        self.addEventListener('push', (event) => this.push(event));

        self.addEventListener('notificationclick', (event:Event) => {
            eventAwait(event, async() => {
                const res = await notifier.notifyClick(event.notification.data);
                if (res.openUrl) {
                    const clientList = await clients.matchAll({ type: 'window', includeUncontrolled: true });
                    for (const client of clientList) {
                        if (urlEqual(client.url, res.openUrl)) {
                            await client.focus();
                            if (res.message) client.postMessage(res.message);

                            return client;
                        }
                    }
                    if (clients.openWindow) {
                        const client = await clients.openWindow(res.openUrl);
                        if (client && res.message) client.postMessage(res.message);

                        return client;
                    }
                }
            });
        });
        /* self.addEventListener('fetch', function(event) {
            if (event.request.mode === 'navigate' ||
                (event.request.method === 'GET' && event.request.headers.get('accept').includes('text/html'))) {
                event.respondWith(
                    fetch(event.request).catch(function(error) {
                        console.log('Fetch selhal; vracím offline stránku.', error);
                        return caches.match(OFFLINE_URL);
                    })
                );
            }
        }); */
    }

    public async activate(event: Event): Promise<any> {
        // setInterval(() => this.tick(), 6000);
    }

    async notify() {

    }

    async install(event: Event) {
    }

    /* private async tick(loadUpdate: boolean|null = null) {
        const notifier = new Notifier()
        loadUpdate ??= frontAppConfig.lastSync === null || DateTime.diff(new Date(), frontAppConfig.lastSync) > 15 * 60 * 1000
        if (frontAppConfig.lastSync === null || loadUpdate) {
            const tl = new AppTL();
            const notifyPack = await tl.getNotifyPack(frontAppConfig.lastSync ?? DateTime.add(new Date(), '-24 h'));
            if (notifyPack.watchedActivity?.dtStart) notifyPack.watchedActivity.dtStart = new Date(notifyPack.watchedActivity?.dtStart);
            await notifier.updateWatch(notifyPack.watchedActivity);
        } else {
            await notifier.updateWatch();
        }
    } */

    public static async call(call: string, ...args: any[]): Promise<any> {
        const reg = await navigator.serviceWorker?.ready;
        if (reg?.active) {
            reg.active.postMessage({
                call,
                args,
            });
        }
    }

    private push(event: Event) {
        if (!event.data) return;
        notifier.proccesPush(event.data.json());
    }
}

// @ts-ignore
function eventAwait(
    event: Event,
    action: () => Promise<any> | any,
): any { // Funkce eventAwait nic nevrací
    const res = action();
    if (res instanceof Promise) {
        event.waitUntil(res);
    }
    return res;
}